import { InternalAxiosRequestConfig } from 'axios';

import i18n from '@/config/i18n';

import { useUserStore } from '../hooks/UserStore';

export class HttpRequestInterceptors {
  private config: InternalAxiosRequestConfig;

  constructor(config: InternalAxiosRequestConfig) {
    this.config = config;
  }

  stringifyParams = () => {
    if (this.config.params && typeof this.config.params === 'object') {
      const stringifiedParams: Record<string, string> = {};
      Object.keys(this.config.params).forEach(key => {
        const value = this.config.params[key];
        if (value !== null && value !== undefined) {
          stringifiedParams[key] =
            typeof value === 'object' ? JSON.stringify(value) : String(value);
        }
      });

      this.config.params = stringifiedParams;
    }

    return this;
  };

  setLanguageHeader = () => {
    this.config.headers.locale = i18n.language || 'pt-BR';

    return this;
  };

  setAccountIdHeader = () => {
    const { accountId } = useUserStore.getState();

    const urlsToIgnoreUndefinedData = ['/user/get-user-info', '/oauth/token'];

    const shouldIgnore = urlsToIgnoreUndefinedData.some(url =>
      this.config.url?.includes(url),
    );

    if (accountId && !shouldIgnore) {
      this.config.headers.account = accountId;
    }

    return this;
  };

  build() {
    return this.config;
  }
}
